import React from 'react'
import { hooks } from '@front/volcanion'

import EventHeader from './Event'
import ActionHeader from './Action'

const withContainer = props => {
  const [model_name] = hooks.useFormState('model_name')

  return model_name === 'event'
    ? <EventHeader {...props} />
    : <ActionHeader {...props} />
}

export default withContainer
